import TwoColorCollarAndSides from 'components/icons/TwoColorCollarAndSides';
import TwoColorCollarAndEdges from 'components/icons/TwoColorCollarAndEdges';
import TwoColorCollarShouldersEdgesAndSides from 'components/icons/TwoColorCollarShouldersEdgesAndSides';
import TwoColorCollarShouldersEdgesAndThickSides from 'components/icons/TwoColorCollarShouldersEdgesAndThickSides';
import TwoColorCollarArmsAndEdges from 'components/icons/TwoColorCollarArmsAndEdges';
import TwoColorCollarArmsAndSides from 'components/icons/TwoColorCollarArmsAndSides';
import TwoColorCollarInvertedArmsAndEdges from 'components/icons/TwoColorCollarInvertedArmsAndEdges';
import TwoColorOneVerticalStripe from 'components/icons/TwoColorOneVerticalStripe';
import TwoColorThinVerticalStripes from 'components/icons/TwoColorThinVerticalStripes';
import TwoColorThinVerticalStripesArms from 'components/icons/TwoColorThinVerticalStripesArms';
import TwoColorVerticalStripes from 'components/icons/TwoColorVerticalStripes';
import TwoColorFullVerticalStripes from 'components/icons/TwoColorFullVerticalStripes';
import TwoColorVerticalStripesFullLength from 'components/icons/TwoColorVerticalStripesFullLength';
import TwoColorVariableVerticalStripes from 'components/icons/TwoColorVariableVerticalStripes';
import TwoColorHorizontalSplit from 'components/icons/TwoColorHorizontalSplit';
import TwoColorOneHorizontalStripe from 'components/icons/TwoColorOneHorizontalStripe';
import TwoColorOneHorizontalStripeArms from 'components/icons/TwoColorOneHorizontalStripeArms';
import TwoColorHorizontalStripesArms from 'components/icons/TwoColorHorizontalStripesArms';
import TwoColorHorizontalStripes from 'components/icons/TwoColorHorizontalStripes';
import TwoColorHorizontalStripesShoulders from 'components/icons/TwoColorHorizontalStripesShoulders';
import TwoColorThinHorizontalStripesArms from 'components/icons/TwoColorThinHorizontalStripesArms';
import TwoColorThinHorizontalStripes from 'components/icons/TwoColorThinHorizontalStripes';
import TwoColorHorizontalStripesGradient from 'components/icons/TwoColorHorizontalStripesGradient';
import TwoColorGradient from 'components/icons/TwoColorGradient';
import TwoColorGradientEdges from 'components/icons/TwoColorGradientEdges';
import TwoColorDiagonalFullColor from 'components/icons/TwoColorDiagonalFullColor';
import TwoColorDiagonalStripeTopLeftToRight from 'components/icons/TwoColorDiagonalStripeTopLeftToRight';
import TwoColorDiagonalStripeTopRightToLeft from 'components/icons/TwoColorDiagonalStripeTopRightToLeft';
import TwoColorTwoDiagonalStripesTopLeftToRight from 'components/icons/TwoColorTwoDiagonalStripesTopLeftToRight';
import TwoColorTwoDiagonalStripesTopRightToLeft from 'components/icons/TwoColorTwoDiagonalStripesTopRightToLeft';
import TwoColorCheckers from 'components/icons/TwoColorCheckers';
import TwoColorCheckeredDiagonal from 'components/icons/TwoColorCheckeredDiagonal';
import TwoColorCollar from 'components/icons/TwoColorCollar';
import TwoColorCollarArmsBottom from 'components/icons/TwoColorCollarArmsBottom';
import TwoColorWithArmsCollarArmsBottom from 'components/icons/TwoColorWithArmsCollarArmsBottom';
import ThreeColorVerticalStripes from 'components/icons/ThreeColorVerticalStripes';

export default function (patternId: number): any {
  const kitTypes: Record<number, any> = {
    8: TwoColorCollarAndSides,
    9: TwoColorCollarAndEdges,
    10: TwoColorCollarShouldersEdgesAndSides,
    11: TwoColorCollarShouldersEdgesAndThickSides,
    12: TwoColorCollarArmsAndEdges,
    13: TwoColorCollarArmsAndSides,
    14: TwoColorCollarInvertedArmsAndEdges,
    // 15: undefined,
    16: TwoColorOneVerticalStripe,
    17: TwoColorThinVerticalStripes,
    18: TwoColorFullVerticalStripes,
    19: TwoColorThinVerticalStripesArms,
    20: TwoColorVerticalStripes,
    21: TwoColorVerticalStripesFullLength,
    22: TwoColorVariableVerticalStripes,
    23: TwoColorHorizontalSplit,
    24: TwoColorOneHorizontalStripe,
    25: TwoColorOneHorizontalStripeArms,
    26: TwoColorHorizontalStripesArms,
    27: TwoColorHorizontalStripes,
    28: TwoColorHorizontalStripesShoulders,
    29: TwoColorThinHorizontalStripesArms,
    30: TwoColorThinHorizontalStripes,
    31: TwoColorHorizontalStripesGradient,
    32: TwoColorGradient,
    33: TwoColorGradientEdges,
    34: TwoColorDiagonalFullColor,
    35: TwoColorDiagonalStripeTopLeftToRight,
    36: TwoColorDiagonalStripeTopRightToLeft,
    37: TwoColorTwoDiagonalStripesTopLeftToRight,
    38: TwoColorTwoDiagonalStripesTopRightToLeft,
    39: TwoColorCheckers,
    40: TwoColorCheckeredDiagonal,
    41: TwoColorCollarArmsBottom,
    42: TwoColorWithArmsCollarArmsBottom,
    43: TwoColorCollar,
    44: ThreeColorVerticalStripes,
  };

  return kitTypes[patternId];
}
